import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Modal, Button, Row, Col, Radio, InputNumber, message, Input, Select, Spin } from 'antd';
const Option = Select.Option;

@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixClsNow: 'sys-ecode-maintainerConfig',
  }
  componentWillUnmount() {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ mainTainerConfigVisible: false, detailConfigParams: {} });
  }
  onCancel = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ mainTainerConfigVisible: false });
  }
  onSubmit = () => {
    const { ecodeDemoStore: { addMaintainer } } = this.props;
    addMaintainer();
  }
  handleSelectChange = (value) => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ currentMainTainer: value, searchUsers: [], fetching: false });
  }
  getConfigs = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    let { ecodeDemoStore: { detail, detailConfigParams, currentMainTainer, searchUsers, fetching, getUser } } = this.props;
    detail = toJS(detail);
    detailConfigParams = toJS(detailConfigParams);
    return [
      {
        title: '案例名称',
        dataIndex: 'title',
        key: 'title',
        width: '10%',
        render: () => {
          const val = detailConfigParams.title ? detailConfigParams.title : 'title';
          return (
            <span>{val}</span>
          )
        }
      },
      {
        title: '维护人',
        dataIndex: 'mainTainer',
        key: 'mainTainer',
        width: '10%',
        render: () => {
          const val = toJS(currentMainTainer)
          return (
            <Select
              mode="multiple"
              labelInValue
              value={val}
              placeholder="选择维护人"
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              onSearch={getUser}
              onChange={this.handleSelectChange}
              style={{ width: '100%' }}
            >
              {toJS(searchUsers).map(d => (
                <Option key={d.id}>{d.username}</Option>
              ))}
            </Select>
          )
        }
      },
    ]
  }
  render() {
    const { prefixClsNow, ecodeDemoStore: { mainTainerConfigVisible } } = this.props;
    const configs = this.getConfigs();
    return (
      <Modal
        title="维护人"
        visible={mainTainerConfigVisible}
        onCancel={this.onCancel}
        footer={
          [
            (<Button onClick={this.onSubmit} key="detailSubmit" type="primary">确定</Button>),
            (<Button onClick={this.onCancel} key="detailCancel">返回</Button>),
          ]
        }
      >
        {
          configs.map((config) => (
            <Row key={config.key} className={`${prefixClsNow}-form`}>
              <Col span={8} className={`${prefixClsNow}-label`}>{config.title}：</Col>
              <Col span={16} className={`${prefixClsNow}-wrapper`}>{config.render()}</Col>
            </Row>
          ))
        }
      </Modal>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/MainTainerConfig.js